module.exports = __webpack_public_path__ + "sa.eba985d64d7bc395ea0b.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/sa.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/sa.svg
// module chunks = styles